export default __webpack_public_path__ + "static/media/spring.b701f1fc.svg";